export function pad(n: number, width: number, z: string = '0'): string {
  const nn = n + '';
  return nn.length >= width ? nn : new Array(width - nn.length + 1).join(z) + n;
};